import * as Ably from "ably";
import { API_BASE } from "@/lib/kfmApi";

// Browser never holds the Ably key. It fetches a short-lived, room-scoped TokenRequest
// from our FastAPI backend (cookie-authenticated); Ably refreshes it automatically.
export function createRoomClient(code) {
  const client = new Ably.Realtime({
    authCallback: async (_params, cb) => {
      try {
        const res = await fetch(
          `${API_BASE}/ably/token-request?room_id=${encodeURIComponent(code)}`,
          { credentials: "include" }
        );
        if (!res.ok) throw new Error(`Ably auth failed: ${res.status}`);
        cb(null, await res.json());
      } catch (e) {
        cb(e, null);
      }
    },
  });
  const channel = client.channels.get(`room:${code}`);
  return { client, channel };
}
